import { motion } from "framer-motion";
import { Info } from "lucide-react";
import { SectionHeader } from "./Reveal";
import { EASE } from "../../lib/motion";

const SHAPES = [
  <path d="M12 2.5 21 20 H3 Z" key="t" />,
  <rect x="3" y="3" width="18" height="18" rx="5" key="s" />,
  <circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" strokeWidth="2.6" key="c" />,
  <path d="M12 2 22 12 12 22 2 12 Z" key="d" />,
  <path d="M12 2 21 7 v10 l-9 5 -9-5 V7 Z" key="h" />,
  <path d="M4 5 h16 v6 H4 Z M4 13 h16 v6 H4 Z" key="r" />,
];

export default function LogoCloud() {
  return (
    <div data-testid="client-logo-cloud">
      <SectionHeader
        eyebrow="Clientes"
        title="Organizaciones que confían en nuestra tecnología"
        align="center"
        className="mx-auto"
      />
      <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
        {SHAPES.map((shape, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.55, delay: i * 0.07, ease: EASE }}
            className="flex h-24 items-center justify-center gap-2.5 rounded-2xl border border-dashed border-border bg-card/40 text-muted-foreground/60"
            data-testid={`client-logo-placeholder-${i}`}
          >
            <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true">
              {shape}
            </svg>
            <span className="text-[11px] font-medium">Logo del cliente</span>
          </motion.div>
        ))}
      </div>
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.3, duration: 0.6 }}
        className="mx-auto mt-6 flex max-w-xl items-center justify-center gap-2 text-center text-xs text-muted-foreground"
      >
        <Info className="h-3.5 w-3.5 shrink-0" />
        Publicamos únicamente logos y testimonios de clientes con autorización expresa. Este
        espacio está preparado para presentarlos.
      </motion.p>
    </div>
  );
}
